import api from '@/util/app-api'

class GatewayService {
  verifyZarinPal (verify) {
    return api.post('purchase/VerifyZarinPal', verify, { authHeader: false, contentType: 'application/json' })
  }
  
  memberVerifyZarinPal (verify) {
    return api.post('memberPurchase/VerifyZarinPal', verify, { authHeader: false, contentType: 'application/json' })
  }

  verifyZibal (verify) {
    return api.post('purchase/VerifyZibal', verify, { authHeader: false, contentType: 'application/json' })
  }
  
  memberVerifyZibal (verify) {
    return api.post('memberPurchase/VerifyZibal', verify, { authHeader: false, contentType: 'application/json' })
  }

  memberVerifySep (verify) {
    return api.post('memberPurchase/VerifySep', verify, { authHeader: false, contentType: 'application/json' })
  }

  memberVerifyNextPay (verify) {
    return api.post('memberPurchase/VerifyNextPay', verify, { authHeader: false, contentType: 'application/json' })
  }
  
}

export default new GatewayService()
